import PromptInput from "common/widgets/PromptList/PromptInput";
import FileInput from "app/widgets/FileInput/FileInput";
import FileInputDataSource from "common/framework/FileInputDataSource";
import FileInputState from "common/enums/FileInputState";

const FileInputPromptInput = PromptInput.extend({

    options: {
        name: "FileInputPromptInput"
    },

    init: function(element, options) {
        PromptInput.fn.init.apply(this, arguments);
        if(options.model.allowMultipleValues) {
            this.input.attr("multiple", "true");
        }
        if(options.model.get("extensions")) {
            this.input.attr("accept", options.model.get("extensions").join(","));
        }
        this._dataSource = new FileInputDataSource({
            autoSync: true,
            transport: {
                read: opts => {
                    opts.success((this.options.model.value || []).map(value => {
                        return {
                            name: value.name,
                            id: value.id,
                            documentId: value.documentId,
                            state: FileInputState.EXISTING,
                            canView: value.canView,
                            canDelete: value.canDelete
                        }
                    }))
                },
                create: {
                    url: `${context.path}${options.model.url}`,
                    method: "POST"
                },
                destroy: {
                    event: "uploadRemove"
                },
                parameterMap: this._parameterMap.bind(this)
            },
            schema: {
                parse: this._parse
            }
        });
        this.widget = new FileInput(this.input, {
            dataSource: this._dataSource
        });
        this._updateStyle();
    },

    _parse(id) {
        return {
            id,
            canDelete: true
        };
    },

    _parameterMap() {
        return {
            formSessionId: this.options.model.get("formSessionId")
        }
    },

    onInit(promptList) {
        PromptInput.fn.onInit.apply(this, arguments);
        ["uploadSuccess", "uploadError", "uploadRemove"].forEach(event => {
            this._dataSource.bind(event, e => {
                this.handleChange();
            });
        });
        ["uploadStarted", "uploadSuccess", "uploadError", "uploadRemove"].forEach(event => {
            this._dataSource.bind(event, e => {
                promptList.trigger(event, {
                    file: e.file,
                    promise: e.promise,
                    response: e.response,
                    prompt: this.options.model
                });
            });
        });
        this.widget.bind("view", e => {
            promptList.trigger("uploadView", {
                file: e.file,
                prompt: this.options.model
            });
        });
    },

    updateWidgetValue: $.noop,
    value() {
        const files = this._dataSource.data()
            .filter(f => [FileInputState.EXISTING, FileInputState.SUCCESS].includes(f.get("state")))
            .map(f => f.file);
        if(!files || !files.length) {
            return;
        }
        return files;
    },

    _getFocusWidgets(showAll) {
        if(this.widget && (showAll || (this._dataSource && this._dataSource.data().length > 0))) {
            return [this.widget.button, this.widget.list];
        } else if(this.widget) {
            return [this.widget.button];
        } else {
            return [];
        }
    },

    getMinSize: function() {
        return {
            width: 50,
            height: 50
        }
    },

    getCorrectedMinSize: function() {
        const minSize = this.getMinSize();
        return {
            height: minSize.height,
            width: Math.max(50, this._getContentMinWidth())
        }
    },

    _getContentMinWidth: function() {
        return this.widget.button.element.outerWidth();
    },

    updateStyle: function() {
        PromptInput.fn.updateStyle.apply(this, arguments);
        this._updateStyle();
    },

    updateSize: function() {
        if (this.options.width !== undefined && this.options.height !== undefined) {
            this.setCorrectedSize();
            this.wrapper.css("width", `${this.options.width}px`)
        } else {
            this.wrapper.css("width", "");
        }
        if(this.options.height) {
            const filePickerHeight = this.widget.filePicker.outerHeight();
            const listMargin = 5;
            const listHeight = Math.max(this.options.height - listMargin - filePickerHeight, 50);
            this.widget.list.element.css("max-height", `${listHeight}px`);
            this.wrapper.css("height", `${this.options.height}px`);
        }
    },

    _updateStyle: function() {
        this.setElementStyle(this.widget.button.element);
        this.setElementStyle(this.widget.filePicker);
        this.widget.setOptions({
            instructions: this.options.model.get("label")
        });
    },

    destroy() {
        if(this._dataSource) {
            this._dataSource.unbind();
            delete this._dataSource;
        }
        PromptInput.fn.destroy.apply(this, arguments);
    }
});

kendo.ui.plugin(FileInputPromptInput);
export default FileInputPromptInput;
